// extracted by mini-css-extract-plugin
export default {"container":"Crm_container__NxG7a"};